import './style.scss';
import React, { useEffect, useState } from 'react';
import ErrorImage from '@assets/images/wetu-error.svg';
import { getItineraryIdentifier } from '@utils/Utils';

const ServerErrorPage = ({error}) => {
    const [errorType, setErrorType] = useState(null);

    const itineraryId = getItineraryIdentifier()
    const errorHeader = "Something unexpected went wrong";
    const errorBodyPreview = "Refresh the itinerary preview page or try again later. Please report this problem to the Support Team if it continues.";
    const errorBodyDefault = "Refresh the itinerary page or try again later. Please contact the itinerary creator if the problem continues.";
    
    //encodeURIComponent preserves formatting
    const subject = encodeURIComponent(`Problem previewing Discovery itinerary ${itineraryId}`);
    const body = encodeURIComponent(`Hi Wetu Support,

I’m having trouble previewing Itinerary ${itineraryId}. 

Can you please help me resolve this issue?

Thanks!
        
---
        
For Support Team’s use only: ${error}`);

    const mailtoUrl = `mailto:support@wetu.com?subject=${subject}&body=${body}`;

    useEffect(() => {
        if (window.location.search.includes('?m=d')) {
            setErrorType('preview');
        }
    }, []);

    return (
        <div className="error-container flex items-center justify-center h-screen">
            <div className="error-content flex flex-col items-center justify-center">
                <img src={ErrorImage} alt="Logo" />
                <div className="error-message flex flex-col items-center justify-center">
                    <div className="error-header">{errorHeader}</div>
                    <div className="error-body">
                        {errorType === "preview" ? errorBodyPreview : errorBodyDefault}
                    </div>
                </div>
                <div className="error-buttons flex">
                    <button onClick={() => window.location.reload()}>Refresh page</button>
                    {errorType === "preview" && (
                        <button onClick={() => window.location.href = mailtoUrl}>Report problem</button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ServerErrorPage;
